import styled from "styled-components";

const Cols = styled.div`
  display: flex;
  flex-direction: rows;
  gap: ${({ gap = "1.5rem" }) => gap};
`;

export default Cols;
